import React, { Component } from 'react';

import passengerTypeCopy from '../../constants/passenger-types-copy';
import passengerTypesEnum from '../../constants/passenger-types-enum';

import TranslatedCopy from '../../intl/translated-copy';

const passengerMap = [
  {
    type: passengerTypesEnum.ADULT,
    copyID: passengerTypeCopy.ADULT,
  },
  {
    type: passengerTypesEnum.CHILD,
    copyID: passengerTypeCopy.CHILD,
  },
  {
    type: passengerTypesEnum.INFANT,
    copyID: passengerTypeCopy.INFANT,
  },
];

class CopyNumberOfTravelers extends Component {
  /**
   * @type {Object} props
   * @prop {Object} props.passengersData - Number of travelers by age category
   */

  render() {
    const { className, passengersData, type } = this.props;

    let totalPassengers = 0;
    let typeCount = 0;
    passengerMap.forEach((passenger) => {
      const count = passengersData[passenger.type];

      if (count > 0) {
        typeCount++;
      }

      totalPassengers += count;
    });

    if (type) {
      if (type === 'ADULT') {
        return (
          <span className={ className }>
            { `${passengersData.ADULT} ` }
            <TranslatedCopy copyID={ passengerTypeCopy.ADULT } paxCount={ passengersData.ADULT } />
          </span>
        );
      } else if (type === 'CHILD') {
        return (
          <span className={ className }>
            { `${passengersData.CHILD} ` }
            <TranslatedCopy copyID={ passengerTypeCopy.CHILD } paxCount={ passengersData.CHILD } />
          </span>
        );
      } else if (type === 'INFANT') {
        return (
          <span>
            { `${passengersData.INFANT} ` }
            <TranslatedCopy copyID={ passengerTypeCopy.INFANT } paxCount={ passengersData.INFANT } />
          </span>
        );
      }
    } else {
      if (typeCount > 1 || typeCount === 0) {
        return (
          <span className={ className }>
            { `${totalPassengers} ` }
            <TranslatedCopy copyID='APP_TRAVELER' paxCount={ totalPassengers } />
          </span>
        );
      } else {
        if (passengersData.ADULT > 0) {
          return (
            <span className={ className }>
              { `${passengersData.ADULT} ` }
              <TranslatedCopy copyID={ passengerTypeCopy.ADULT } paxCount={ passengersData.ADULT } />
            </span>
          );
        } else if (passengersData.CHILD > 0) {
          return (
            <span className={ className }>
              { `${passengersData.CHILD} ` }
              <TranslatedCopy copyID={ passengerTypeCopy.CHILD } paxCount={ passengersData.CHILD } />
            </span>
          );
        } else if (passengersData.INFANT > 0) {
          return (
            <span>
              { `${passengersData.INFANT} ` }
              <TranslatedCopy copyID={ passengerTypeCopy.INFANT } paxCount={ passengersData.INFANT } />
            </span>
          );
        }
      }
    }

    return null;
  }
}

export default CopyNumberOfTravelers;
